import { FC } from 'react';

import { OBCardRow, OBCircleStatus } from 'features/Bento/components';

import { VerificationStatus } from '../../../lib/steps/types';

interface RowStatusProps {
  src: string;
  status: VerificationStatus;
}

/**
 * Switches between the illustration and a tick mark
 * IF and ONLY IF an illustration src has been passed
 *
 */
export const RowStatus: FC<RowStatusProps> = ({ src, status }) => {
  if (!src) {
    return null;
  }

  if (status === VerificationStatus.ToDo) {
    return <OBCardRow.Illustration src={src} />;
  }

  return (
    <OBCircleStatus
      margin="space-8"
      status={status === VerificationStatus.Invalid ? 'error' : 'success'}
    />
  );
};
